const errorReasons = {
  NETWORK: -1,
  EMAIL_NOT_UNIQUE: "NOT_UNIQUE",
  REQUEST_LIMIT_EXEEDED: "113",
  EMAIL_ALREADY_ACTIVATED: "44",
  WRONG_PASSWORD: "101",
  TOKEN_NOT_FOUND:"1014-200",
  ALREADY_USED:"1014-300",
  RESOURCE_NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  RATE_LIMIT_ERROR: 429,
  BAD_REQUEST: 400,
  MULTI_STATUS: 207,
  PASSWORD_HISTORY: "PASSWORD_HISTORY",
  EMAIL_NOT_COMPLIANT: "INVALID_FORMAT",
  SYSTEM_ERROR: "SYSTEM_ERROR",
  INVALID_TOKEN: "invalid_token",
  ACCOUNT_NOT_ACTIVATED: "account activation pending",
  SESSION_HAS_TIMED_OUT: "Session has timed out",
  NAVIGATOR_TIMEOUT: "NotAllowedError",
  PASSKEY_REGISTRATION_WRONG_PASSWORD: "Login failure",
  NO_CONSENTS_FOUND: "NotFound Error: No consents found for contact"
};

const profilePages = {
  PERSONAL_DATA: "personal_data",
  ACCOUNT_DATA: "account_data",
  ESIM: "esim",
  CONSENTS: "consents",
  BMW_PAY: "bmw_pay",
  VEHICLES: "vehicles",
  DEALERS: "dealers"
};
const profilePagesTracking = {
  personal_data: "personal data",
  account_data: "account data",
  esim: "eSim",
  consents: "consent management",
  bmw_pay: "bmw pay",
  vehicles: "vehicles",
};
const profilePictureBrands = {
  rr: "ROLLS_ROYCE",
  bmw: "BMW",
  mini: "MINI",
  dontknow: "BMW_I"
};
const closedBy = {
  BUTTON: 0,
  CANCEL: 1
};

const loginTypes = {
  CREDENTIALS: "CREDENTIALS",
  ID_TOKEN: "ID_TOKEN",
  COOKIE: "COOKIE",
  PASSKEY: "PASSKEY"
};

const loginInitializers = {
  LOGIN_PAGE: "LOGIN_PAGE",
  PRE_REGISTER_PAGE: "PRE_REGISTER_PAGE",
  LINK_PAGE: "LINK_PAGE",
  PROFILE_PAGE: "PROFILE_PAGE"
};

const tolerantConfigs = {
  quality: 50,
  interactive_request: {
    country: "country",
    regionCode: "province",
    postalCode: "postalcode",
    city: "city",
    street: "street",
    houseNumber: "number",
    strSuppl1: "addressline2",
    strSuppl2: "addressline3"
  },
  fc_city_request: {
    country: "country",
    city: "city"
  },
  fc_postalcode_request: {
    country: "country",
    postalCode: "postalcode"
  },
  fc_street_request: {
    country: "country",
    postalCode: "postalcode",
    city: "city",
    street: "street"
  },
  fc_housenumber_request: {
    country: "country",
    postalCode: "postalcode",
    city: "city",
    street: "street",
    houseNumber: "number"
  },
  fc_singleline_request: {
    country: "country",
    singleline: "singleline"
  },
  fc_post_singleline_value_fields: [
    "houseNumber", 
    "street", 
    "city", 
    "postalCode", 
    "regionCode",
    "strSuppl1"
  ],
  response: {
    city: "city",
    country: "countrycode",
    houseNumber: "HouseNumber",
    postalCode: "postalcode",
    regionCode: "provincecode",
    strSuppl1: {
      fastComplete: "subbuilding | building | addressline2",
      manageTolerant: "addressline2"
    },
    strSuppl2: "addressline3",
    street: 'dependantstreet | street',
    postSingleLine: "post_singleline"
  },
};

const tolerantProfileKey = {
  INTERACTIVE: "interactive",
  FC_CITY: "fc_city",
  FC_POSTAL_CODE: "fc_postalcode",
  FC_STREET: "fc_street",
  FC_HOUSE_NUMBER: "fc_housenumber",
  FC_SINGLE_LINE: "fc_singleline",
};

const authMethodsForPersonalIdChange = {
  PASSKEY: "PASSKEY",
  TWO_FACTOR_AUTH: "2FA"
};

const actionMode = {
  VIEW: null,
  ADD: -1,
};

const enums = {
  tolerantConfigs,
  tolerantProfileKey,
  profilePictureBrands,
  errorReasons,
  profilePages,
  profilePagesTracking,
  closedBy,
  authMethodsForPersonalIdChange,
  actionMode,
  loginTypes,
  loginInitializers
};


export default enums;
